// 홍보센터 사이드바/드롭다운 공용 메뉴 (모든 홍보센터 페이지에서 공유)
export const promotionMenus = [
  { label: '사회적기업', path: '/promotion/social' },
  { label: '여성기업', path: '/promotion/women' },
];
